import { formatToValueOrZero, plainAverage } from '@utils/formatters';
import { formatSecondsToTime } from '@utils/stringFormatters';
import { ReactNode } from 'react';
import { compose } from 'redux';

import createColumn from './createColumn';

export const timeSignal = {
    format: formatSecondsToTime,
    average: plainAverage,
    unit: 'operatingTime',
};

export const timeSignalWithDefaultValue = {
    ...timeSignal,
    format: compose<ReactNode>(formatToValueOrZero, formatSecondsToTime),
};

export const drivingTime = createColumn({
    key: 'drivingTime',
    dataField: 'drivingTime',
    labelId: 'drivingTime',
    formatter: timeSignal.format,
    dataSort: true,
});

export const idlingTime = createColumn({
    key: 'idlingTime',
    dataField: 'idlingTime',
    labelId: 'idlingTime',
    formatter: timeSignal.format,
});

export const idlingTimeBev = createColumn({
    key: 'idlingTime',
    dataField: 'idlingTime',
    labelId: 'idlingTimeBev',
    formatter: timeSignal.format,
});

export const fuelAndElectricIdlingTime = createColumn({
    key: 'idlingTime',
    dataField: 'idlingTime',
    labelId: 'fuelAndElectricIdlingTime',
    formatter: timeSignal.format,
});

export const operatingTime = createColumn({
    key: 'operatingTime',
    dataField: 'operatingTime',
    labelId: 'operatingTime',
    formatter: timeSignal.format,
});

export const activeCoastingTime = createColumn({
    key: 'activeCoastingTime',
    dataField: 'activeCoastingTime',
    labelId: 'activeCoastingTime',
    formatter: timeSignal.format,
});

export const passiveCoastingTime = createColumn({
    key: 'passiveCoastingTime',
    dataField: 'passiveCoastingTime',
    labelId: 'passiveCoastingTime',
    formatter: timeSignal.format,
});

export const coastingCCTime = createColumn({
    key: 'coastingCcTime',
    dataField: 'coastingCcTime',
    labelId: 'coastingCcTime',
    formatter: timeSignal.format,
});

export const kickdownTime = createColumn({
    key: 'kickdownTime',
    dataField: 'kickdownTime',
    labelId: 'kickdownTime',
    formatter: timeSignal.format,
});

export const accelerationPedalTimeWithCc = createColumn({
    key: 'accelerationPedalTimeWithCc',
    dataField: 'accelerationPedalTimeWithCc',
    labelId: 'accelerationPedalTimeWithCc',
    formatter: timeSignal.format,
});

export const serviceBrakeTime = createColumn({
    key: 'serviceBrakeTime',
    dataField: 'serviceBrakeTime',
    labelId: 'serviceBrakeTime',
    formatter: timeSignal.format,
});

export const motorBrakeTime = createColumn({
    key: 'motorBrakeTime',
    dataField: 'motorBrakeTime',
    labelId: 'motorBrakeTime',
    formatter: timeSignal.format,
});

export const retarderTime = createColumn({
    key: 'retarderTime',
    dataField: 'retarderTime',
    labelId: 'retarderTime',
    formatter: timeSignal.format,
});

export const cruiseControlTimeInPotential = createColumn({
    key: 'cruiseControlTimeInPotential',
    dataField: 'cruiseControlTimeInPotential',
    labelId: 'cruiseControlTimeInPotential',
    formatter: timeSignal.format,
});

export const noCruiseControlTimeInPotential = createColumn({
    key: 'noCruiseControlTimeInPotential',
    dataField: 'noCruiseControlTimeInPotential',
    labelId: 'noCruiseControlTimeInPotential',
    formatter: timeSignal.format,
});

export const coastingTime = createColumn({
    key: 'coastingTime',
    dataField: 'coastingTime',
    labelId: 'coastingTime',
    formatter: timeSignal.format,
});

export const driveProgramActiveTime = createColumn({
    key: 'driveProgramActiveTime',
    dataField: 'driveProgramActiveTime',
    labelId: 'driveProgramActiveTime',
    formatter: timeSignalWithDefaultValue.format,
});

export const driveProgramEfficiencyTime = createColumn({
    key: 'driveProgramEfficiencyTime',
    dataField: 'driveProgramEfficiencyTime',
    labelId: 'driveProgramEfficiencyTime',
    formatter: timeSignalWithDefaultValue.format,
});

export const driveProgramEfficiencyPlusTime = createColumn({
    key: 'driveProgramEfficiencyPlusTime',
    dataField: 'driveProgramEfficiencyplusTime',
    labelId: 'driveProgramEfficiencyplusTime',
    formatter: timeSignalWithDefaultValue.format,
});

export const driveProgramEmergencyTime = createColumn({
    key: 'driveProgramEmergencyTime',
    dataField: 'driveProgramEmergencyTime',
    labelId: 'driveProgramEmergencyTime',
    formatter: timeSignalWithDefaultValue.format,
});

export const driveProgramFluidTime = createColumn({
    key: 'driveProgramFluidTime',
    dataField: 'driveProgramFluidTime',
    labelId: 'driveProgramFluidTime',
    formatter: timeSignalWithDefaultValue.format,
});

export const driveProgramHeavyDutyTime = createColumn({
    key: 'driveProgramHeavyDutyTime',
    dataField: 'driveProgramHeavydutyTime',
    labelId: 'driveProgramHeavydutyTime',
    formatter: timeSignalWithDefaultValue.format,
});

export const driveProgramManoeuverTime = createColumn({
    key: 'driveProgramManoeuverTime',
    dataField: 'driveProgramManeuverTime',
    labelId: 'driveProgramManeuverTime',
    formatter: timeSignalWithDefaultValue.format,
});

export const driveProgramManualTime = createColumn({
    key: 'driveProgramManualTime',
    dataField: 'driveProgramManualTime',
    labelId: 'driveProgramManualTime',
    formatter: timeSignalWithDefaultValue.format,
});

export const driveProgramOffroadTime = createColumn({
    key: 'driveProgramOffroadTime',
    dataField: 'driveProgramOffroadTime',
    labelId: 'driveProgramOffroadTime',
    formatter: timeSignalWithDefaultValue.format,
});

export const driveProgramOffroadWithAssistanceTime = createColumn({
    key: 'driveProgramOffroadWithAssistanceTime',
    dataField: 'driveProgramOffroadwithassistanceTime',
    labelId: 'driveProgramOffroadwithassistanceTime',
    formatter: timeSignalWithDefaultValue.format,
});

export const driveProgramPerformanceTime = createColumn({
    key: 'driveProgramPerformanceTime',
    dataField: 'driveProgramPerformanceTime',
    labelId: 'driveProgramPerformanceTime',
    formatter: timeSignalWithDefaultValue.format,
});

export const driveProgramTotalTime = createColumn({
    key: 'driveProgramTotalTime',
    dataField: 'driveProgramTotalTime',
    labelId: 'driveProgramTotalTime',
    formatter: timeSignalWithDefaultValue.format,
});

export const accTime = createColumn({
    key: 'accTime',
    dataField: 'accTime',
    labelId: 'accTime',
    formatter: timeSignalWithDefaultValue.format,
});

export const noAccTime = createColumn({
    key: 'noAccTime',
    dataField: 'noAccTime',
    labelId: 'noAccTime',
    formatter: timeSignalWithDefaultValue.format,
});

export const pccaTime = createColumn({
    key: 'pccaTime',
    dataField: 'pccaTime',
    labelId: 'pccaTime',
    formatter: timeSignalWithDefaultValue.format,
});

export const noPccaTime = createColumn({
    key: 'noPccaTime',
    dataField: 'noPccaTime',
    labelId: 'noPccaTime',
    formatter: timeSignalWithDefaultValue.format,
});

export const harshAccelerationMediumTime = createColumn({
    key: 'harshAccelerationMediumTime',
    dataField: 'harshAccelerationMediumTime',
    labelId: 'harshAccelerationMediumTime',
    formatter: timeSignalWithDefaultValue.format,
});

export const harshAccelerationHardTime = createColumn({
    key: 'harshAccelerationHardTime',
    dataField: 'harshAccelerationHardTime',
    labelId: 'harshAccelerationHardTime',
    formatter: timeSignalWithDefaultValue.format,
});

export const harshBrakingMediumTime = createColumn({
    key: 'harshBrakingMediumTime',
    dataField: 'harshBrakingMediumTime',
    labelId: 'harshBrakingMediumTime',
    formatter: timeSignalWithDefaultValue.format,
});

export const harshBrakingHardTime = createColumn({
    key: 'harshBrakingHardTime',
    dataField: 'harshBrakingHardTime',
    labelId: 'harshBrakingHardTime',
    formatter: timeSignalWithDefaultValue.format,
});

export const excessiveIdlingTime = createColumn({
    key: 'excessiveIdlingTime',
    dataField: 'excessiveIdlingTime',
    labelId: 'excessiveIdlingTime',
    formatter: timeSignalWithDefaultValue.format,
});

export const acceptableIdlingTime = createColumn({
    key: 'acceptableIdlingTime',
    dataField: 'acceptableIdlingTime',
    labelId: 'acceptableIdlingTime',
    formatter: timeSignalWithDefaultValue.format,
});
